// v7.51 — Lista blacklist de nomes/URLs de imagens conhecidos como
// "pratos fantasma" plantados pelos seeds antigos (db.js seed v0,
// KAVEN_DELIVERY_MENU v3, beverages v3.2) e backfill v6 de imagens.
//
// Esta lista é o ÚLTIMO RECURSO de defesa: mesmo que tombstones por
// stableId/numericId falhem (porque o device do cliente nunca rodou o
// backfill de stableId, ou tem cache de service worker), o filtro
// por NOME + heurística (price=0 OR URL de unsplash do seed) bloqueia
// o item de aparecer no Delivery, na listagem do Admin, e DELETA do
// Dexie local automaticamente no boot.
//
// IMPORTANTE: o filtro só ataca itens FANTASMAS — pratos legítimos
// adicionados pelo admin manualmente, mesmo com nome igual ao seed,
// passam livres porque têm preço > 0 e/ou imagem diferente das URLs
// do seed.

/**
 * Nomes EXATOS plantados por seeds antigos (db.js seed v0 + KAVEN_DELIVERY_MENU
 * v3 + KAVEN_BEVERAGES_MENU v3.2 + v6 backfill imageUrl).
 */
export const GHOST_NAMES = new Set([
  // Seed v0 (firstRun) — Quentinhas, Marmitas, Bebidas
  'Quentinha de Carne',
  'Quentinha de Frango',
  'Quentinha de Peixe',
  'Marmita GG Carne',
  'Marmita GG Frango',
  'Refrigerante 2L',
  'Suco Natural 1L',
  'Agua Mineral 500ml',
  'Água Mineral 500ml',
  // KAVEN_DELIVERY_MENU v3 — Executivo Premium, Churrasco Box, Massas, Família
  'Executivo de Frango Grelhado',
  'Executivo Parmegiana',
  'Executivo Costela Barbecue',
  'Executivo Cupim Assado',
  'Executivo Mineiro',
  'Box Fraldinha',
  'Box Fradininha', // typo já confirmado no vídeo do usuário
  'Box Costela BBQ',
  'Box Misto Kaven',
  'Penne 4 Queijos com Frango',
  'Lasanha Bolonhesa',
  'Escondidinho de Carne',
  'Fricassê de Frango',
  'Strogonoff Premium',
  'Combo Família Churrasco',
  'Combo Família Mineiro',
  'Combo Família Parmegiana',
  // KAVEN_BEVERAGES_MENU v3.2 — Bebidas com price=0
  'Coca-Cola Lata 350ml',
  'Guaraná Antarctica 350ml',
  'Coca-Cola 2L',
  'Suco Natural 500ml',
]);

/**
 * URLs de imagens unsplash plantadas pelo v6 migration backfill.
 * Qualquer item cuja `imageUrl` comece com um desses identificadores
 * é considerado fantasma (mesmo que o admin tenha renomeado o prato).
 */
const GHOST_IMAGE_FRAGMENTS = [
  'photo-1544025162-d76694265947', // Quentinha de Carne
  'photo-1598103442097-8b74394b95c6', // Quentinha de Frango
  'photo-1535140728325-a4d3707eee94', // Quentinha de Peixe
  'photo-1565299624946-b28f40a0ae38', // Marmita GG Carne
  'photo-1569058242261-9cb5f72e3e4f', // Marmita GG Frango
  'photo-1629203851288-4062bb2b85a5', // Refrigerante 2L
  'photo-1600271886742-f049cd451bba', // Suco Natural 1L
  'photo-1559839734-2b71ea197ec2', // Agua Mineral 500ml
  'photo-1554866585-cd94860890b7', // Refrigerante 2L (alt)
];

/**
 * Heurística: é fantasma?
 *
 * Critério (qualquer um basta):
 *   - Nome bate na lista E (preço == 0 OU sem imagem OU imagem do seed)
 *   - Imagem do seed (independente de nome)
 *   - Preço == 0 E sem imagem (item órfão sem cadastro real)
 */
export function isGhostMenuItem(item) {
  if (!item) return false;
  const name = String(item.name || '').trim();
  const nameMatch = GHOST_NAMES.has(name);
  const price = Number(item.price || 0);
  const priceZero = !Number.isFinite(price) || price === 0;
  const imgUrl = String(item.imageUrl || '');
  const noImage = imgUrl.length < 5;
  const seedImage = GHOST_IMAGE_FRAGMENTS.some((frag) => imgUrl.includes(frag));

  if (seedImage) return true; // imagem do seed = definitivamente fantasma
  if (nameMatch && (priceZero || noImage || seedImage)) return true;
  if (priceZero && noImage) return true; // item órfão
  return false;
}

/**
 * Filtra um array de menuItems removendo os fantasmas.
 * Usado nas queries do DeliveryPage para que mesmo se o item estiver
 * no Dexie local, ele NUNCA seja renderizado.
 */
export function filterOutGhosts(items) {
  if (!Array.isArray(items)) return items;
  return items.filter((it) => !isGhostMenuItem(it));
}
